import { useState } from "react";
import { Modal } from "react-bootstrap";
import Styles from "./ViewSubscriptionHistory.module.css";
import cancelIcon from "../../../Assets/cross.png";
import Label from "../../../Assets/label.png";
import Description from "../../../Assets/description.png";
import Currency from "../../../Assets/currency.png";
import Inventory from "../../../Assets/inventory.png";
import ProductsBag from "../../../Assets/shoping_bag.png";
import CalanderClock from "../../../Assets/calendar_clock.png";

import mail from "../../../Assets/email.png";
import location from "../../../Assets/location_img.png";
import paymentType from "../../../Assets/payment_type.png";
import moment from "moment";

export default function ViewSubscriptionHistory({ viewData, onHide, isShow }) {
  const [readmoreId, setReadmoreId] = useState([]);

  const handleTotalAmount = (data) => {
    const total_amount = data.reduce(
      (prev, current) => prev + current?.total_price,
      0,
    );
    return total_amount + viewData?.delivery_charge;
  };

  return (
    <div>
      <Modal show={isShow} onHide={onHide} centered size="lg">
        <Modal.Body>
          <div className={Styles.cancelImgParentContainer}>
            <div>
              <p className="fontBold">
                Invoice <span className="orange">Details</span>
              </p>
            </div>
            <div className={Styles.cancelImgContainer}>
              <img
                onClick={onHide}
                src={cancelIcon}
                alt="cancel"
                className={Styles.cancelImg}
              />
            </div>
          </div>
          <div>
            <div className={Styles.detailUserContainer}>
              <div className={Styles.userLeftContainer}>
                <img className={Styles.img} src={Label} alt="Plan Title" />
                <p className={Styles.username}>{viewData?.plan_title}</p>
              </div>
              <div className={Styles.userRightContainer}>
                <p className={Styles.username + " text-start"}>
                  Invoice No :
                  <span className={Styles.detail}>
                    {viewData?.invoice_number}
                  </span>
                </p>
              </div>
            </div>
            <div className={Styles.dateTimeContainer}>
              <div className={Styles.dateSingleContainer}>
                <img
                  className={Styles.img}
                  src={CalanderClock}
                  alt="Valid From"
                />
                <p className={Styles.detail}>
                  {viewData?.valid_from
                    ? moment
                        .utc(viewData?.valid_from)
                        .local()
                        .format("DD-MM-YYYY hh:mm A")
                    : "-"}
                </p>
              </div>

              <div className={Styles.dateSingleContainer}>
                <img
                  className={Styles.img}
                  src={CalanderClock}
                  alt="Valid To"
                />
                <p className={Styles.detail}>
                  {viewData?.valid_to
                    ? moment
                        .utc(viewData?.valid_to)
                        .local()
                        .format("DD-MM-YYYY hh:mm A")
                    : "-"}
                </p>
              </div>
              <div className={Styles.dateSingleContainer}>
                <img className={Styles.img} src={CalanderClock} alt="Days" />
                <p className={Styles.detail}>
                  {viewData?.no_of_days ? viewData?.no_of_days : "0"} Days
                </p>
              </div>
            </div>
            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={ProductsBag} alt="Products" />
              <p className={Styles.detail}>
                {viewData?.no_of_products ? viewData?.no_of_products : "0"}{" "}
                Products
              </p>
            </div>

            <div className={Styles.dateTimeContainer}>
              <div className={Styles.dateSingleContainer}>
                <img className={Styles.img} src={Currency} alt="Price" />
                <p className={Styles.detail}>
                  Price: ₹ {viewData?.actual_price}
                </p>
              </div>

              <div className={Styles.dateSingleContainer}>
                <img className={Styles.img} src={Currency} alt="gst" />
                <p className={Styles.detail}>
                  GST: ₹ {parseFloat(viewData.gst_amount ?? "0").toFixed(2)} (
                  {viewData.gst_percent}%)
                </p>
              </div>
              <div className={Styles.dateSingleContainer}>
                <img className={Styles.img} src={Currency} alt="Total Price" />
                <p className={Styles.detail}>
                  Total Price: ₹{" "}
                  {parseFloat(viewData?.total_price ?? "0").toFixed(2)}
                </p>
              </div>
            </div>
            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={Description} alt="profile" />
              <p className={Styles.detail}>{viewData?.description}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
